import React, { useState, useEffect } from 'react';
import api from '../api';
import './Contact.css';

export default function Contact() {
  const [form, setForm] = useState({ name:'', email:'', phone:'', message:'' });
  const [status, setStatus] = useState('');
  const [sending, setSending] = useState(false);
  const [settings, setSettings] = useState({});

  useEffect(() => { api.get('/settings').then(r=>setSettings(r.data)).catch(()=>{}); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try { await api.post('/contact', form); setStatus('success'); setForm({ name:'', email:'', phone:'', message:'' }); }
    catch { setStatus('error'); }
    setSending(false);
  };

  return (
    <div className="contact-page">
      <div className="contact-header">
        <div className="container">
          <p className="tag">Get In Touch</p>
          <h1 className="contact-title">Contact Us</h1>
        </div>
      </div>
      <div className="container contact-body">
        <div className="contact-info-col">
          <h2>ElevenNorth <em>&amp; Co.</em></h2>
          <div className="divider"/>
          <p className="contact-desc">We're here to help with any questions about our wholesale collections, ordering process, or account registration.</p>
          <div className="contact-details">
            <div className="contact-detail">
              <div className="contact-detail-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              </div>
              <div>
                <p className="contact-detail-label">Email</p>
                <a href={`mailto:${settings.contact_email||'info@elevennorth.com'}`}>{settings.contact_email||'info@elevennorth.com'}</a>
              </div>
            </div>
            <div className="contact-detail">
              <div className="contact-detail-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8 19.79 19.79 0 013 1.22 2 2 0 015 .01h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L9.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/></svg>
              </div>
              <div>
                <p className="contact-detail-label">Phone</p>
                <a href={`tel:${settings.contact_phone||''}`}>{settings.contact_phone||'+44 20 0000 0000'}</a>
              </div>
            </div>
          </div>
        </div>
        <div className="contact-form-col">
          {status === 'success' ? (
            <div className="contact-success">
              <div style={{fontSize:'32px',marginBottom:'16px'}}>✓</div>
              <h3>Message Sent</h3>
              <p>Thank you for getting in touch. We'll respond as soon as possible.</p>
              <button className="btn-secondary btn-sm" style={{marginTop:'20px'}} onClick={()=>setStatus('')}>Send Another</button>
            </div>
          ) : (
            <form onSubmit={submit}>
              {status==='error' && <div className="alert alert-error">Something went wrong. Please try again.</div>}
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'20px'}}>
                <div className="form-group"><label>Name *</label><input required value={form.name} onChange={e=>setForm({...form,name:e.target.value})} placeholder="Your name"/></div>
                <div className="form-group"><label>Email *</label><input required type="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} placeholder="your@email.com"/></div>
              </div>
              <div className="form-group"><label>Phone</label><input value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} placeholder="+44..."/></div>
              <div className="form-group"><label>Message *</label><textarea required rows={5} value={form.message} onChange={e=>setForm({...form,message:e.target.value})} placeholder="How can we help?"/></div>
              <button type="submit" className="btn-primary" style={{width:'100%',justifyContent:'center',padding:'16px'}} disabled={sending}>
                {sending?'Sending...':'Send Message'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
